class mailchimpSuscription {
    constructor() {
        if (document.getElementById('mc-form')) { 
            this.init();
        }
    }
    init() {
        const SUBSCRIBE_API = '/.netlify/functions/subscribe?email=';
        const subEmail = document.querySelector('#mc-email');
        const subButton = document.querySelector('#mc-submit');
        const subStatus = document.querySelector('#mc-result');

        document.getElementById('mc-form').addEventListener('submit', function (e) {
            e.preventDefault();
            const email = subEmail.value;
            if(!email) return;
            console.log('add '+email);
            subButton.disabled = true;
            subStatus.innerHTML = 'Subscribing you...';
            fetch(SUBSCRIBE_API + email)
            .then(res => {
                return res.json()
            })
            .then(res => {
                console.log('status',res.status);
                if(res.status === 'subscribed') {
                    subStatus.innerHTML = 'Thanks, you have been subscribed!';
                } else if(res.status === 400) {
                    subStatus.innerHTML = `Sorry, there was an error: ${res.detail}`;
                }
                subButton.disabled = false;
            })
            .catch(e => {
                console.log('error result', e);
            });

        });
    }
}

export default mailchimpSuscription;
